var exports = {
  "B": "ChecksStatusBadge__sB1PyG",
};

module.exports = exports;
